/**
 @ngdoc service
 @name logService

 @description
 I find myself writing log methods a lot in services and controllers. Decided to reduce that practice.
 1) Inject the service
 2) Initialise the service with a unique name - suggest file name

 @example
 //initialisation of log service
 logObj = logService.init('FilterTableCtrl',DEBUG);
 //calling
 logObj.log('getSearchData()',[searchUrl,searchParams]);
 logObj.log('getSearchData() response.data',response.data);
 //Tab version
 logObj.logTab('methodName1',['param1','param2']);
 logObj.logTab('methodName2',['param1','param2']);
 logObj.logTab('methodName2',['param1','param2'],'returnValue');
 logObj.logTab('methodName1',['param1','param2'],'returnValue');

 var logObj = logService.init('filterDataService',true);


 */
angular.module('app').service('logService', function() {
    this.logger = {};

    this.init = function(fileId, debug){
        //if(debug) console.log('logService.init()',fileId,debug);
        /**
         * Encapsulated the logger
         * @type {{debug: *, deepDebug: boolean, tabCount: number, log: log, logTab: logTab}}
         */
        return this.logger[fileId] = {
            fileId: fileId,
            debug: debug,
            deepDebug: false,
            tabCount: 0,
            _this: this,
            /**
             * A basic console.log message for files but only if debug is set to true
             * @param identifier String - Method name or an identifier of what happened. Part zero of console.log
             * @param params Object Array - []. Part one of console.log
             * @param returnData optional String/Object - the returned data from called function. Part three of console.log
             * @param isDeepDebug Boolean - Set true if a repetitive call like inside a loop. This will be displayed if deepDebug is set to true
             */
            log: function(identifier, returnData, isDeepDebug){
                logFull(identifier, null, returnData, isDeepDebug, this.fileId, this.debug, this.deepDebug);
            },
            /**
             * Same as the above method but it's expected to be called at the start and end of a method call. It will increment tabs making it easier to read
             * @param identifier String - Method name or an identifier of what happened. Part zero of console.log
             * @param params Object Array - []. Part one of console.log
             * @param returnData optional String/Object - the returned data from called function. Part three of console.log
             * @param isDeepDebug Boolean - Set true if a repetitive call like inside a loop. This will be displayed if deepDebug is set to true
             */
            logTab: function(identifier, params, returnData, isDeepDebug){
                if(returnData){
                    this.tabCount--;
                    if(this.tabCount<0) {
                        this.tabCount = 0;
                        console.warn('A logTab() has been incorrectly set up. Occurred at:',identifier);
                    }
                }
                logFull('\t'.repeat(this.tabCount)+identifier, params, returnData, isDeepDebug, this.fileId, this.debug, this.deepDebug);
                //Assumes if return data is provided your have exiting a method
                if(!returnData){
                    this.tabCount++;
                }
            },
            logMap: function(map){
                for(var idx in map){
                    this.log(idx, map[idx]);
                }
            }

        };
    };
    var logFull = function(identifier, params, returnData, isDeepDebug, fileId, debug, deepDebug){
        //console.log('logFull', identifier, params, returnData, isDeepDebug);
        if( ( isDeepDebug!=true && debug ) || ( isDeepDebug==true && deepDebug ) ){
            if(params==null)
                console.log( fileId, identifier, returnData );
            else
                console.log( fileId, identifier, params, returnData );
        }
    };
});